import type { ColumnDef } from "@tanstack/react-table";
import type { AuditLogRow } from "@/lib/audit-log.api";
import { formatAuditDateTime, humanizeAuditAction } from "./auditLogPage.helpers";
import { AuditLogMetadataPopover } from "./components/AuditLogMetadataPopover";

export function createAuditLogColumns(): ColumnDef<AuditLogRow, any>[] {
  return [
    {
      accessorKey: "createdAt",
      header: "Date / heure",
      cell: ({ row }) => (
        <span className="text-[12px] text-body">
          {formatAuditDateTime(row.original.createdAt)}
        </span>
      ),
    },
    {
      accessorKey: "actorName",
      header: "Utilisateur",
      cell: ({ row }) => (
        <span className="text-[12px] text-body">{row.original.actorName ?? "Système"}</span>
      ),
    },
    {
      accessorKey: "action",
      header: "Action",
      cell: ({ row }) => (
        <span className="text-[12px] text-body" title={row.original.action}>
          {humanizeAuditAction(row.original.action)}
        </span>
      ),
    },
    {
      accessorKey: "entityType",
      header: "Entité",
      cell: ({ row }) => (
        <span className="text-[12px] text-muted-foreground">
          {row.original.entityType}
          {row.original.entityId ? ` #${row.original.entityId}` : ""}
        </span>
      ),
    },
    {
      id: "details",
      header: "Détails",
      cell: ({ row }) => <AuditLogMetadataPopover metadata={row.original.metadata} />,
    },
  ];
}
